import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function UnsereKernkompetenzen() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const services = [{
    title: "Express-Logistik",
    description: "Direktfahrten bis 3,5 Tonnen ohne Umladung. Deutschlandweite Kurierfahrten mit Fokus auf Schnelligkeit und absolute Termintreue.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1619366/img/logistics_express_van.png",
    link: "/CourierExpressTripsPage",
    alt: "Moderner Logistik-Transporter auf der Autobahn"
  }, {
    title: "Ausräumung",
    description: "Professionelle Entrümpelung und fachgerechte Entsorgung für Privat- und Geschäftskunden. Wir schaffen Platz und Ordnung in Ihren Objekten mit höchster Diskretion.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1619366/img/ausraeumen.png",
    link: "/RelocationAndClearingPage",
    alt: "Professionelle Ausräumung eines Gebäudes"
  }, {
    title: "Kontakt",
    description: "Haben Sie Fragen zu unseren Logistiklösungen oder benötigen Sie ein Angebot? Unser Team steht Ihnen jederzeit für eine individuelle Beratung zur Verfügung.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1619366/img/kontakt.png",
    link: "/ContactRequestPage",
    alt: "Kontaktieren Sie das ErzWerk Logistik Team"
  }];
  return <section data-section-id="3769" id="unsere-transportlösungen" ref={ref} className={`py-20 bg-background transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <style dangerouslySetInnerHTML={{
      __html: `
        h1, h2, h3, h4 {
          font-family: var(--font-serif), Georgia, serif;
        }
      `
    }} />
      <div className="container mx-auto px-4">
        <div className="mb-12 text-center">
          <h2 className="text-4xl md:text-5xl font-black tracking-tighter text-foreground mb-4 uppercase">
            Unsere Transportlösungen
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-medium">
            Präzision und Zuverlässigkeit für Ihre wertvollsten Güter. 
            Maßgeschneiderte Logistiklösungen für Industrie und Privatkunden.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-10">
          {services.map((service, i) => <Link key={service.title} to={service.link} className="block group h-full w-full" data-index={i}>
              <Card className="relative h-[500px] w-full overflow-hidden border-0 rounded-sm shadow-2xl transition-all duration-300 group-hover:ring-2 group-hover:ring-primary">
                {}
                <div className="absolute inset-0 w-full h-full">
                  <img src={service.image} data-wvc-srcset={`${service.image}-wvc-srcset`} data-wvc-sizes={`${service.image}-wvc-sizes`} alt={service.alt} loading="lazy" className="w-full h-full object-cover grayscale-[0.2] transition-transform duration-700 ease-out group-hover:scale-105 group-hover:grayscale-0" />
                </div>

                {}
                <div className="absolute inset-0 bg-gradient-to-t from-[#05070a] via-[#05070a]/70 to-transparent opacity-90 transition-opacity duration-500 group-hover:opacity-95" />

                {}
                <CardContent className="relative z-10 flex flex-col justify-center h-full text-white !m-0 !p-[48px]">
                  <div className="transform transition-transform duration-500 translate-y-4 group-hover:translate-y-0">
                    <h3 className="text-3xl md:text-5xl font-black mb-4 text-white tracking-tighter uppercase">
                      {service.title}
                    </h3>
                    <p className="text-gray-300 text-lg mb-8 max-w-md leading-relaxed opacity-90 font-medium">
                      {service.description}
                    </p>
                    
                    {}
                    <div className="opacity-0 transform translate-y-4 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0">
                      <Button variant="outline" className="border-white text-white hover:bg-white hover:text-black rounded-sm">
                        Mehr erfahren <ArrowRight className="ml-2 h-4 w-4" />
                      </Button>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}